// nav/how-to-play-settings.js: B2-10 room-aware How to Play copy.
//
// The How-to-Play overlay mounts above RoomView (in App), so the room's
// target score + stick-the-dealer setting reach it through this tiny
// store: RoomView publishes the live room settings, App reads them when
// the overlay opens, and HowToPlayView falls back to the defaults
// (target 10, stick on) on surfaces with no room.

/** @type {{ targetScore: 7|10, stickTheDealer: boolean }} */
let current = { targetScore: 10, stickTheDealer: true };

/** @type {Set<(settings: { targetScore: 7|10, stickTheDealer: boolean }) => void>} */
const listeners = new Set();

function notify() {
  const snapshot = { ...current };
  for (const fn of listeners) {
    try { fn(snapshot); } catch (err) { console.warn('[how-to-play-settings] room-settings listener threw, skipping:', err instanceof Error ? err.message : err); }
  }
}

/**
 * @param {{ targetScore?: 7|10, stickTheDealer?: boolean }} [settings]
 */
export function setHowToPlayRoomSettings(settings = {}) {
  current = {
    targetScore: settings.targetScore === 7 ? 7 : 10,
    stickTheDealer: settings.stickTheDealer === false ? false : true,
  };
  notify();
}

export function resetHowToPlayRoomSettings() {
  current = { targetScore: 10, stickTheDealer: true };
  notify();
}

/** @returns {{ targetScore: 7|10, stickTheDealer: boolean }} */
export function getHowToPlayRoomSettings() {
  return { ...current };
}

/**
 * W6: subscribe to room-setting changes so an OPEN How-to-Play panel
 * follows the room's current target + stick-the-dealer instead of going
 * stale. The listener fires immediately with the current values (so the
 * panel never starts stale) and on every set/reset. Returns unsubscribe.
 *
 * @param {(settings: { targetScore: 7|10, stickTheDealer: boolean }) => void} listener
 * @returns {() => void}
 */
export function subscribeHowToPlayRoomSettings(listener) {
  listeners.add(listener);
  try { listener({ ...current }); } catch (err) { console.warn('[how-to-play-settings] new subscriber threw on initial fire, still subscribed:', err instanceof Error ? err.message : err); }
  return () => { listeners.delete(listener); };
}
